Rows are individual framework tests and attempts. Scenarios are the customer-
meaningful ticket/spec groups reconstructed from test keys.

Attempt folding is important:

  failed only             -> failed
  passed only             -> passed
  failed then passed      -> flaky
  skipped only            -> skipped

The latest attempt supplies the retained row/evidence, but its verdict reflects
all attempts. A successful retry therefore does not erase the original failure.
Scenario verdicts are worst-step-wins: failed, then flaky, then passed, then
skipped. `resultsTruncated: true` means tests that never started may have no row;
do not read those counts as a complete suite.
